import { SvgIcon } from '@mui/material';

const Illustration = () => (
  <SvgIcon
    viewBox="0 0 92 68"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 92, height: 68, fill: 'none' }}
    data-testid="illustrationeIcon"
  >
    <path
      d="M66.8118 54.3213H12.3077V59.4153H66.8118V54.3213Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M55.9126 55.0938H23.2747V60.1878H55.9126V55.0938Z"
      fill="#373B49"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M4.95673 42.6543V43.1057V64.7713C4.95673 65.9964 5.92427 66.9637 7.14981 66.9637H12.5035C13.729 66.9637 14.6965 65.9964 14.6965 64.7713V57.0336L4.95673 42.6543Z"
      fill="#373B49"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M74.1673 42.6543V43.1057V64.7713C74.1673 65.9964 73.1998 66.9636 71.9742 66.9636H66.6205C65.395 66.9636 64.4275 65.9964 64.4275 64.7713V57.0336L74.1673 42.6543Z"
      fill="#373B49"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M74.274 49.6871L74.2741 49.6871L74.2756 49.6732C74.4 48.4913 74.4504 47.5748 74.5036 46.6073L74.5117 46.4614C74.5679 45.4408 74.6319 44.3387 74.7918 42.7719L74.7919 42.7719L74.7929 42.7602C74.92 41.1927 75.0991 39.8259 75.2454 38.7095C75.3223 38.1227 75.3902 37.6051 75.4366 37.1639C75.4456 37.0786 75.4351 36.9925 75.4058 36.912C75.1367 36.1722 74.7363 35.3054 74.2692 34.5041C73.9572 33.9431 73.6428 33.4364 73.3254 32.9853C73.1331 32.3427 72.85 31.4063 72.1843 30.4082C71.6927 29.671 71.1923 29.0885 70.7296 28.6676C69.9439 25.8906 68.7106 22.4904 66.6597 18.8384C65.7424 17.2009 64.7616 15.7635 63.8564 14.4708L63.8564 14.4708L63.8504 14.4625C62.7196 12.9081 61.0253 11.9942 59.2025 11.7838C58.1467 11.6596 57.0347 11.5945 55.9939 11.5335C55.9354 11.53 55.8771 11.5266 55.819 11.5232C50.1923 11.1354 44.7617 11.0062 39.6576 11.0062C34.5538 11.0062 29.1235 11.1354 23.4971 11.5232C22.908 11.5559 22.3366 11.605 21.782 11.6532L21.7152 11.659C21.1805 11.7055 20.6622 11.7506 20.1449 11.781L20.1449 11.7809L20.1348 11.7817C18.2927 11.9233 16.5237 12.9115 15.4569 14.4736C14.5522 15.7656 13.5721 17.2022 12.6554 18.8386C10.6045 22.4905 9.37128 25.8907 8.58563 28.6676C8.12289 29.0885 7.62247 29.671 7.13087 30.4082C6.46524 31.4063 6.18215 32.3427 5.98986 32.9853C5.67148 33.4378 5.35601 33.9463 5.04306 34.5095L5.04301 34.5094L5.03949 34.516C4.58574 35.3584 4.18224 36.1621 3.90947 36.912C3.87731 37.0004 3.86778 37.0955 3.88174 37.1885C4.07384 38.4688 4.33012 40.3901 4.52236 42.7602L4.52224 42.7603L4.52343 42.7719C4.68332 44.3384 4.74726 45.4564 4.80354 46.4854L4.81046 46.6119C4.86398 47.5923 4.91415 48.5114 5.03915 49.6689C5.17018 51.1726 5.43138 53.192 5.95166 55.6626L5.95209 55.6646C6.2024 56.8323 7.21027 57.5935 8.30969 57.5935H39.5931H71.0055C72.1645 57.5935 73.1896 56.7687 73.3677 55.6409C73.8119 53.2292 74.0698 51.2524 74.2618 49.7799L74.274 49.6871Z"
      fill="#F15C5C"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M17.2757 52.5166L17.2112 52.5811C16.9532 53.097 16.4372 53.3549 15.8567 53.4194L8.95494 53.6773C7.79391 53.7418 6.95538 52.5811 7.34239 51.4849L7.8584 49.9374C8.11641 49.1636 8.95495 48.7122 9.72897 48.8412L16.1792 50.0663C17.2112 50.2598 17.7917 51.5494 17.2757 52.5166Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M39.5918 47.0354C44.1069 47.0998 49.4605 46.7774 55.2657 45.4878C56.0397 45.2944 56.8137 45.1009 57.5878 44.9075C58.5553 44.6496 58.9423 43.6179 58.3618 42.9086C57.9103 42.3283 57.3298 41.7479 56.6847 41.1676C56.6847 41.1676 56.6847 41.1676 56.6202 41.1031C54.6207 39.3621 51.9116 38.3304 49.0735 38.266C48.88 38.266 48.6865 38.266 48.4285 38.266C45.3969 38.2015 42.4298 38.266 39.5918 38.266C36.7537 38.266 33.7866 38.2015 30.755 38.266C30.5615 38.266 30.368 38.266 30.11 38.266C27.2719 38.3304 24.5628 39.3621 22.5633 41.1031C22.5633 41.1031 22.5633 41.1031 22.4988 41.1676C21.8537 41.7479 21.2732 42.3283 20.8217 42.9086C20.2412 43.6179 20.6282 44.6496 21.5957 44.9075C22.3698 45.1009 23.0793 45.2944 23.9178 45.4878C29.723 46.7774 35.0766 47.1643 39.5918 47.0354Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M39.5923 53.8109C45.0105 53.8109 50.3641 53.6819 55.7823 53.424C56.3628 53.424 56.7498 52.7792 56.4273 52.2633C56.1693 51.8765 55.9758 51.4896 55.7178 51.1027C55.5888 50.9092 55.3308 50.7803 55.0728 50.7803C49.9126 51.0382 44.7524 51.1027 39.5923 51.1027C34.4321 51.1027 29.272 50.9737 24.1118 50.7803C23.8538 50.7803 23.5958 50.9092 23.4668 51.1027C23.2088 51.4896 23.0153 51.8765 22.7573 52.2633C22.4348 52.7147 22.8218 53.424 23.4023 53.424C28.756 53.7464 34.1741 53.8109 39.5923 53.8109Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M39.5923 53.8109C45.0105 53.8109 50.3641 53.6819 55.7823 53.424C56.3628 53.424 56.7498 52.7792 56.4273 52.2633C56.1693 51.8765 55.9758 51.4896 55.7178 51.1027C55.5888 50.9092 55.3308 50.7803 55.0728 50.7803C49.9126 51.0382 44.7524 51.1027 39.5923 51.1027C34.4321 51.1027 29.272 50.9737 24.1118 50.7803C23.8538 50.7803 23.5958 50.9092 23.4668 51.1027C23.2088 51.4896 23.0153 51.8765 22.7573 52.2633C22.4348 52.7147 22.8218 53.424 23.4023 53.424C28.756 53.7464 34.1741 53.8109 39.5923 53.8109Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M61.9112 52.5166L61.9758 52.5811C62.2338 53.097 62.7498 53.3549 63.3303 53.4194L70.232 53.6773C71.393 53.7418 72.2315 52.5811 71.8445 51.4849L71.3285 49.9374C71.0705 49.1636 70.232 48.7122 69.458 48.8412L63.0078 50.0663C61.9112 50.2598 61.3307 51.5494 61.9112 52.5166Z"
      fill="#4D5160"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M7.59941 36.0752L4.63232 39.6216"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M7.14823 34.0736L6.37421 33.1709"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M8.9549 28.915C9.0194 29.6888 9.2129 30.7205 9.92242 31.8167C10.6319 32.9129 11.4705 33.5577 12.1155 34.009C12.6315 34.3959 13.083 34.6538 13.4055 34.7828"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M9.66461 26.208C9.92262 26.5304 10.3741 27.0463 11.0192 27.6911C13.5347 30.2058 15.6633 30.7862 17.9209 32.3337C19.0819 33.1075 20.7589 34.4616 22.3715 36.7184"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M10.9525 27.692C11.2105 26.08 11.533 24.2745 12.2425 22.2756C13.21 19.3095 14.4355 16.8592 15.5966 15.0537"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M39.5935 26.0139C44.8826 26.0784 50.2363 26.1429 55.719 26.3363C59.4601 26.4653 63.2012 26.5943 66.8133 26.7877C66.2328 24.5953 65.4588 22.2095 64.3622 19.5658C63.7817 18.1472 63.1367 16.8576 62.4917 15.697C62.1692 15.0521 61.4596 14.6653 60.7501 14.6008C58.299 14.5363 55.7835 14.4718 53.2679 14.4073C48.5593 14.3429 43.9796 14.1494 39.529 14.1494C35.0784 14.1494 30.4342 14.3429 25.7901 14.4073C23.2745 14.4718 20.7589 14.5363 18.3079 14.6008C17.5338 14.6008 16.8888 15.0521 16.5663 15.697C15.9213 16.8576 15.3408 18.1472 14.6958 19.5658C13.5992 22.1451 12.8252 24.5953 12.2447 26.7877C15.9213 26.5943 19.5979 26.4653 23.339 26.3363C28.9507 26.1429 34.3043 26.0139 39.5935 26.0139Z"
      fill="#F7F8FC"
      stroke="#4D5160"
      strokeWidth="0.564083"
      strokeLinejoin="round"
    />
    <path
      d="M7.72945 33.8799C9.47101 34.1379 12.4381 34.5892 13.0831 34.7182C13.1476 34.7182 13.2766 34.7827 13.3411 34.7827L20.4363 38.3291C21.0813 38.6515 21.0169 39.4253 20.3073 39.6832L18.8883 40.1346H18.8238C18.0498 40.2636 13.0831 41.0373 9.342 38.0067C8.11647 36.975 7.34243 35.8144 6.89092 34.9116C6.69741 34.3958 7.14894 33.8154 7.72945 33.8799Z"
      fill="white"
      stroke="#4D5160"
      strokeWidth="0.564083"
      strokeLinejoin="round"
    />
    <path
      d="M71.3918 33.8799C69.6502 34.1379 66.6832 34.5892 66.0381 34.7182C65.9736 34.7182 65.8446 34.7827 65.7801 34.7827L58.6849 38.3291C58.0399 38.6515 58.1044 39.4253 58.8139 39.6832L60.233 40.1346H60.2975C61.0715 40.2635 66.0381 41.0373 69.7792 38.0067C71.0048 36.975 71.7788 35.8144 72.2303 34.9116C72.4883 34.3958 72.0368 33.8154 71.3918 33.8799Z"
      fill="white"
      stroke="#4D5160"
      strokeWidth="0.564083"
      strokeLinejoin="round"
    />
    <path
      d="M60.749 37.3614C58.3624 37.039 55.9113 36.7811 53.3313 36.5876C48.4291 36.2008 43.8495 36.0718 39.5279 36.0718H39.6569C35.3352 36.0073 30.7556 36.2008 25.8535 36.5876C23.2734 36.7811 20.8223 37.039 18.4357 37.3614"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M10.05 52.7747C10.9049 52.7747 11.598 52.1107 11.598 51.2917C11.598 50.4726 10.9049 49.8086 10.05 49.8086C9.19499 49.8086 8.50189 50.4726 8.50189 51.2917C8.50189 52.1107 9.19499 52.7747 10.05 52.7747Z"
      fill="#F7F8FC"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M67.5211 51.2917C67.5211 50.4534 68.2306 49.8086 69.0692 49.8086C69.9077 49.8086 70.6172 50.5179 70.6172 51.2917C70.6172 52.1299 69.9077 52.7747 69.0692 52.7747C68.2306 52.7747 67.5211 52.1299 67.5211 51.2917Z"
      fill="#F7F8FC"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M71.5215 36.0752L74.5531 39.6216"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M71.9718 34.0736L72.8103 33.1709"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M70.1671 28.915C70.1026 29.6888 69.9091 30.7205 69.1996 31.8167C68.4901 32.9129 67.6515 33.5577 67.0065 34.009C66.4905 34.3959 66.039 34.6538 65.7165 34.7828"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M69.5213 26.208C69.2633 26.5304 68.8117 27.0463 68.1667 27.6911C65.6511 30.2058 63.5226 30.7862 61.265 32.3337C60.104 33.1075 58.4269 34.4616 56.8144 36.7184"
      stroke="#4D5160"
      strokeWidth="0.188028"
      strokeLinejoin="round"
    />
    <path
      d="M68.169 27.692C67.911 26.08 67.5885 24.2745 66.879 22.2756C65.9115 19.3095 64.6859 16.8592 63.5249 15.0537"
      stroke="#4D5160"
      strokeWidth="0.255041"
      strokeLinejoin="round"
    />
    <path
      d="M8.24506 25.9493C8.24506 24.6597 6.63252 23.5635 4.56846 23.5635C2.5044 23.5635 0.891846 24.5952 0.891846 25.9493C0.891846 27.2389 2.5044 28.3351 4.56846 28.3351C6.63252 28.3351 8.24506 27.2389 8.24506 25.9493Z"
      fill="#F15C5C"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M5.01923 28.3333C5.34174 28.9781 5.66425 29.6874 5.98675 30.3322C6.24476 30.7836 6.43827 31.235 6.69628 31.7508C7.21229 30.977 7.72831 30.2033 8.30883 29.4295C7.98632 28.7847 7.72831 28.2044 7.4058 27.5595C7.2123 27.4951 6.63177 27.3661 5.92225 27.624C5.47074 27.8175 5.14823 28.1399 5.01923 28.3333Z"
      fill="#F98585"
      stroke="#4D5160"
      strokeWidth="0.564083"
      strokeMiterlimit="10"
    />
    <path
      d="M74.5525 28.3351C76.5831 28.3351 78.2291 27.2669 78.2291 25.9493C78.2291 24.6316 76.5831 23.5635 74.5525 23.5635C72.522 23.5635 70.8759 24.6316 70.8759 25.9493C70.8759 27.2669 72.522 28.3351 74.5525 28.3351Z"
      fill="#F15C5C"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeLinejoin="round"
    />
    <path
      d="M74.1006 28.3333C73.7781 28.9781 73.4556 29.6874 73.1331 30.3322C72.8751 30.7836 72.6816 31.235 72.4236 31.7508C71.9076 30.977 71.3916 30.2033 70.811 29.4295C71.1335 28.7847 71.3915 28.2044 71.7141 27.5595C71.9076 27.4951 72.4881 27.3661 73.1976 27.624C73.6491 27.8175 73.9716 28.1399 74.1006 28.3333Z"
      fill="#F98585"
      stroke="#4D5160"
      strokeWidth="0.564083"
      strokeMiterlimit="10"
    />
    <path
      d="M74.2539 1.03613C72.6119 3.36071 61.6776 8.13409 57.3819 8.13409C57.3819 15.8797 57.3819 18.3197 57.3819 24.9917C57.3819 32.9148 73.3042 41.5921 74.245 41.8405C75.1858 41.5832 91.1081 32.3115 91.1081 25.879C91.1081 19.2069 91.1081 15.8797 91.1081 8.13409C86.4219 8.13409 75.8958 3.36071 74.2539 1.03613Z"
      fill="#CFD2E0"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.1999 36.8206C72.5846 35.889 70.0906 34.3186 67.7209 32.4199C63.3632 28.9419 61.8188 26.2447 61.8188 24.9937V11.8713C65.8305 10.8421 70.7829 8.79256 74.2266 6.6543C77.6702 8.82805 82.6226 10.8687 86.6698 11.8979V25.8809C86.6076 26.4221 85.374 28.7378 80.5369 32.4909C78.1583 34.3452 75.7531 35.8979 74.1999 36.8206Z"
      fill="white"
      stroke="#4D5160"
      strokeWidth="1.12817"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.05"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.1892 41.8225V1.12266C74.2121 1.09346 74.2336 1.06461 74.2537 1.03613C75.8956 3.36071 86.4218 8.13409 91.108 8.13409V25.879C91.108 32.3115 75.1856 41.5832 74.2448 41.8405C74.23 41.8366 74.2114 41.8306 74.1892 41.8225Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default Illustration;
